module.exports = __webpack_public_path__ + "img/corneal-staining-0.8ca296f8.jpg";